import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory, useRouteMatch } from "react-router-dom";
import AppStateHandler from "src/StateHandlers/AppStateHandler";
import { useChatState } from "src/StateHandlers/ChatStateHandler";

function Drawer() {
  const { url } = useRouteMatch();
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const { user } = AppStateHandler.getState();
  const [{ chatList = [], }] = useChatState();
  const chatCount = chatList.filter(
    (_: any) => _?.unReadCount !== 0 && user?.username === _?.receiverId,
  ).length;

  return (
    <nav id="sidebar">
      <ul className="list-unstyled components" id="sidebar_menu">
        <li className={url.indexOf('home') !== -1 ? 'active' : ''}>
          <Link to="/home" onClick={() => history.push('/home')}>
            <img
              src={url.indexOf('home') !== -1 ? '/assets/images/homeactive@2x.png' : '/assets/images/homeinactive@2x.png'} alt="icon"
              height="25"
              className={`${i18n.dir()==='rtl'?'ml-3':'mr-3'}`}
            />
            {t('Home')}
          </Link>
        </li>
        <li className={url.indexOf('messages') !== -1 ? 'active' : ''}>
          <Link to="/messages" onClick={() => history.push('/messages')}>
            <img
              src={url.indexOf('messages') !== -1 ? '/assets/images/messagesactive@2x.png' : '/assets/images/messagesinactive@2x.png'}
              alt="icon"
              height="25"
              className={`${i18n.dir()==='rtl'?'ml-3':'mr-3'}`}
            />
            {t("Messages")}
            {chatCount ? <span className="badge" style={{ top: '82px', right: '85px' }}>{chatCount}</span> : ""}
          </Link>
        </li>
        <li className={url.indexOf('groups') !== -1 ? 'active' : ''}>
          <Link to="/groups" onClick={() => history.push('/groups')}>
            <img
              src={url.indexOf('groups') !== -1 ? '/assets/images/groupsactive@2x.png' : '/assets/images/groupsinactive@2x.png'}
              alt="icon"
              height="25"
              className={`${i18n.dir()==='rtl'?'ml-3':'mr-3'}`}
            />
            {t("Groups")}
          </Link>
        </li>
        <li className={url.indexOf('sales') !== -1 ? 'active' : ''}>
          <Link to="/sales" >
            <img
              src={url.indexOf('sales') !== -1 ? '/assets/images/saleactive@2x.png' : '/assets/images/saleinactive@2x.png'}
              alt="icon"
              height="25"
              className={`${i18n.dir()==='rtl'?'ml-4':'mr-4'}`}
            />
            {t('Listing')}
          </Link>
        </li>
        <li className={url.indexOf('business') !== -1 ? 'active' : ''}>
          <Link to="/business">
            <img
              src={url.indexOf('business') !== -1 ? '/assets/images/businessactive@2x.png' : '/assets/images/businessinactive@2x.png'}
              alt="icon"
              height="25"
              className={`${i18n.dir()==='rtl'?'ml-3':'mr-3'}`}
            />
            {t('Business')}
          </Link>
        </li>
      </ul>
    </nav>
  );
}

export default Drawer;
